import axiosInstance from '../../../helpers/axios';

const getQuizResultsRequest = (featureId) => {
  const query = featureId ? `?feature_id=${featureId}` : '';
  return axiosInstance.get(`progress/get_quiz_results${query}`);
};

export default getQuizResultsRequest;
